import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminSales() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/api/admin/payments").then(({data}) => setList(data));
  }, []);
  const totalPaid = list.filter((p) => p.status === "paid").reduce((a, p) => a + (p.amount || 0), 0);

  return (
    <div data-testid="admin-sales">
      <div className="label-eyebrow">Sales</div>
      <h1 className="font-display font-black text-3xl mt-1">Payments</h1>
      <div className="mt-4 bg-white border border-[#E5E7EB] rounded-xl p-5 inline-block">
        <div className="label-eyebrow">Total revenue</div>
        <div className="font-display font-black text-3xl mt-1">${totalPaid.toFixed(2)} USD</div>
      </div>

      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6]">
            <tr><th className="px-4 py-3 text-left">Email</th><th className="px-4 py-3 text-left">Course</th><th className="px-4 py-3 text-left">Amount</th><th className="px-4 py-3 text-left">Status</th><th className="px-4 py-3 text-left">Date</th></tr>
          </thead>
          <tbody>
            {list.map((p) => (
              <tr key={p.id} className="border-t border-[#E5E7EB]">
                <td className="px-4 py-3">{p.user_email}</td>
                <td className="px-4 py-3">{p.course_title}</td>
                <td className="px-4 py-3">${p.amount.toFixed(2)}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-bold uppercase px-2 py-1 rounded ${p.status === "paid" ? "bg-[#064E3B]/10 text-[#064E3B]" : "bg-[#F3F4F6] text-[#4B5563]"}`}>{p.status}</span>
                </td>
                <td className="px-4 py-3 text-[#4B5563]">{p.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
